var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "login-bg-main-section register-main-section width-full float-l",
      attrs: { id: "login-main-hr" }
    },
    [
      _vm.currentEnvironment
        ? _c(
            "div",
            { staticClass: "notification-block notification-block-top" },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-left-section float-l" },
        [
          _c("router-link", { attrs: { to: { path: "/" } } }, [
            _c("img", {
              attrs: {
                src: "/static/images/vvg-home-logo.png",
                alt: "Velocity Truck Center"
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "register-right-main-section width-full float-l" },
        [
          _c(
            "form",
            { staticClass: "cmxform", attrs: { id: "form", name: "form" } },
            [
              _c("div", { staticClass: "register-form-main" }, [
                _c("h2", [_vm._v(" Register Here ")]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.username,
                            expression: "username"
                          }
                        ],
                        attrs: {
                          id: "username",
                          type: "text",
                          placeholder: "",
                          name: "uname",
                          required: ""
                        },
                        domProps: { value: _vm.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.username))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        attrs: {
                          id: "email",
                          type: "text",
                          placeholder: "",
                          name: "email",
                          required: ""
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.email))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.firstName,
                            expression: "firstName"
                          }
                        ],
                        attrs: {
                          id: "firstName",
                          type: "text",
                          placeholder: "",
                          name: "fname",
                          required: ""
                        },
                        domProps: { value: _vm.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.firstName = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.firstName))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lastName,
                            expression: "lastName"
                          }
                        ],
                        attrs: {
                          id: "lastName",
                          type: "text",
                          placeholder: "",
                          name: "lname",
                          required: ""
                        },
                        domProps: { value: _vm.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.lastName = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.lastName))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        attrs: {
                          id: "password",
                          type: "password",
                          placeholder: "",
                          name: "pwd",
                          required: ""
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.password))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cpassword,
                            expression: "cpassword"
                          }
                        ],
                        attrs: {
                          id: "cpassword",
                          type: "password",
                          placeholder: "",
                          name: "cpwd",
                          required: ""
                        },
                        domProps: { value: _vm.cpassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.cpassword = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.cpassword))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          name: "locationIdSearch",
                          id: "locationIdSearch",
                          label: "text",
                          searchable: false,
                          filterable: false,
                          options: _vm.locationArr,
                          placeholder: "Select State",
                          required: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.changedValueLocation()
                          }
                        },
                        model: {
                          value: _vm.locationIdSearch,
                          callback: function($$v) {
                            _vm.locationIdSearch = $$v
                          },
                          expression: "locationIdSearch"
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.locationIdSearch))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-6 col-md-6 col-lg-6" },
                    [
                      _c("font", {}, [
                        _c("label", {
                          staticClass: "error text-danger",
                          attrs: { id: "errorMsg" }
                        }),
                        _c("br")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.registerButton == true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "btm-login-section btm-register-section col-12 float-l"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "btn-login-main float-l col-12" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "register_button hvr-sweep-to-right-red",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.submitRegistrationForm()
                                      }
                                    }
                                  },
                                  [_vm._v("Register Now")]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary alert-dismissible",
        attrs: { role: "alert", "aria-live": "polite", "aria-atomic": "true" }
      },
      [
        _c("div", { staticClass: "scroll-left" }, [
          _c("p", [_vm._v("This is Test Environment !")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "uname" } },
      [
        _vm._v("Dayforce Id"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "email" } },
      [
        _vm._v("Email"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "fname" } },
      [
        _vm._v("First Name"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "lname" } },
      [
        _vm._v("Last Name"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "pwd" } },
      [
        _vm._v("Password"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "cpwd" } },
      [
        _vm._v("Confirm Password"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "registerlabel", attrs: { for: "locations" } },
      [
        _vm._v("State"),
        _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf3755a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf3755a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = null
// module chunks = 